module.exports = __webpack_public_path__ + "static/media/client-area-provisional-receipt.5dc84917.svg";